import React from 'react';

const AddButton = ({ newEvent }) => {
    return (
        <div className='ba tc dt pa2 ma1 w-100 f5 dim pointer noselect shadow-1 grow bg-dark-gray light-blue br3' onClick={newEvent}>+ NEW EVENT</div>
    )
}

export default AddButton;